export default function dateTime(stgDate:Date) {
  const d = new Date(stgDate);
  const h = d.getHours();
  const m = d.getMinutes();

  const time = stgDate ? new Date(2023, 1, 1, h, m) : '';
  return time;
}
